<template>
  <g>
    <path
      d="M7 19.0002C5.9 19.0002 5 19.9002 5 21.0002H19C19 19.9002 18.1 19.0002 17 19.0002H13V17.0002H16C17.1 17.0002 18 16.1002 18 15.0002H10C8.34 15.0002 7 13.6602 7 12.0002C7 10.9102 7.59 9.96019 8.46 9.44019C8.17 9.03019 8 8.54019 8 8.00019C8 7.79019 8.04 7.58019 8.09 7.38019C6.28 8.13019 5 9.92019 5 12.0002C5 14.7602 7.24 17.0002 10 17.0002V19.0002H7Z"
    />
    <path
      d="M10.5599 5.51018C11.9099 5.54018 12.9999 6.64018 12.9999 8.00018C12.9999 8.75018 12.6699 9.41018 12.1499 9.87018L12.3999 10.5502C12.5899 11.0702 13.1599 11.3402 13.6799 11.1502C13.8699 11.6702 14.4399 11.9402 14.9599 11.7502C15.4799 11.5602 15.7499 10.9902 15.5599 10.4702C16.0799 10.2802 16.3499 9.71018 16.1599 9.19018L14.0999 3.54018C13.9099 3.02018 13.3399 2.75018 12.8199 2.94018C12.6299 2.42018 12.0599 2.15018 11.5399 2.34018C11.0199 2.53018 10.7499 3.10018 10.9399 3.62018C10.4199 3.81018 10.1499 4.38018 10.3399 4.90018L10.5599 5.51018Z"
    />
    <path
      d="M10.5 9.50018C11.3284 9.50018 12 8.82861 12 8.00018C12 7.17176 11.3284 6.50018 10.5 6.50018C9.67157 6.50018 9 7.17176 9 8.00018C9 8.82861 9.67157 9.50018 10.5 9.50018Z"
    />
  </g>
</template>
